// @ts-nocheck

/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-shadow */
/* eslint-disable array-callback-return */

import React, { useEffect, useState, FunctionComponent, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import ReactLoading from 'react-loading'
import Select from 'react-select'

import { Modal } from 'reactstrap'
import { Modal as ModalMobile } from 'antd'
import { useDispatch, useSelector, RootStateOrAny } from 'react-redux'

import { markMoodTooltipAsRead } from 'Redux/actions/sessionNotificationsActions'
import CheckboxAntd from 'Containers/ui/CheckboxAntd'
// import { MoodsComponent } from 'Containers/ui'

import Alert from 'Shared/components/Alert'
import { HINT_GENRES, HINT_LANGUAGES, CLEAR_HINT } from 'Constants/hints'
import { playlistRequirementsLink } from 'Constants/links'
import { UPDATE_GENRES_LIMIT } from 'Constants/errorCodes'
import { Mobile, Desktop } from 'Shared/components/Responsive'
import { Hint } from 'Stories/Hint/Hint.stories'
import { HintGuide } from 'Stories/HintGuide/HintGuide.stories'
import { useIntercom } from 'react-use-intercom'
import { IconCheckMark } from 'Stories/Icon/Icon.stories'
import Warning from 'Shared/img/Warning.svg'
import arrowLeftIcon from 'Shared/icons/arrow-left.svg'
import { customStyles } from 'Shared/components/CustomStyles'
import { DropdownIndicator } from 'Shared/components/DropdownIndicator'
import {
  GreenBtn,
  WhiteGreenBtn,
  GreyBtnDisabled,
} from 'Stories/Button/Button.stories'
import { DottedBtn } from 'Stories/DottedBtn/DottedBtn.stories'
import CheckedCircleIcon from 'Shared/img/checked-circle.png'
import IconDanger from 'Shared/img/Danger.svg'
import GenresSelectionGuide from '../GenresSelectionGuide'
import PlaylistVocalSettings from '../PlaylistVocalSettings'
import GenresSelectionGuideModal from '../GenresSelectionGuideModal'
import PlaylistVocalSettingsModal from '../PlaylistVocalSettingsModal'

import {
  ActionsForSelectGenresAndLanguagesEnum,
  Mood,
  MoodName,
  Genre,
  Language,
  ErrorWithFlag,
} from '../../../../Types'

import {
  IconCheckMarkWrapper,
  LanguagesSelectItem,
  LanguagesSelectItemAnimation,
  GotItContainer,
} from '../styles'

import '../style.scss'

import * as S from './styles'
import * as P from './props'

const PlaylistEditModal: FunctionComponent<P.PlaylistEditModalProps> = ({
  item: {
    genres,
    selectedGenres,
    selectedLanguages,
    selectedMoods,
    id,
    relevantGenres,
    playListInfo,
  },
  isOpen,
  toggle,
  handleSave,
  isPlaylist,
  loading,
  settingNewPlaylist,
  languages,
  allMoods,
  userEmail,
  setPageTitle,
}) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const moodTooltipShown: boolean = useSelector(
    (state: RootStateOrAny) => state.sessionNotifications.moodTooltipShown
  )

  const [genresItem, setModalGenres] = useState({
    selectedGenres: [],
    genresToSelect: [],
  })
  const [moodsChecked, setMoodsChecked] = useState<number[]>([])
  const [selectedInputGenres, setSelectedInputGenres] = useState([])
  const [isGenresLimit, setGenresLimit] = useState<boolean>(false)

  const [selectedInputLanguages, setSelectedLanguages] = useState<
    Array<Language>
  >([])
  const [hintGuide, setHint] = useState({ component: null, name: null })
  const [modal, setModalValue] = useState(false)
  const [successContent, setSuccessContent] = useState(false)
  const [modalVocal, setModalValueVocal] = useState(false)
  const [isUpdateGenresLimitAlert, setIsUpdateGenresLimitAlert] = useState(
    false
  )

  const markTooltipAsRead = () => {
    setTimeout(() => {
      dispatch(markMoodTooltipAsRead())
    }, 5000)
  }

  useEffect(() => {
    setMoodsChecked(selectedMoods.map(el => el.id))
  }, [selectedMoods])

  useEffect(() => {
    if (!moodTooltipShown) {
      markTooltipAsRead()
    }
  }, [moodTooltipShown])
  const [languageSearchMobileMode, setLanguageSearchMobileMode] = useState(
    false
  )

  const meetConditions = useMemo(
    () => !!(relevantGenres && relevantGenres.length),
    [relevantGenres]
  )

  const getGenresToSelect = (): Array<Genre> => {
    let filteredGenres = genres
    // @ts-ignore
    genres.map((item): void => {
      for (let i = 0; i < selectedGenres.length; i += 1) {
        if (item.id === selectedGenres[i].id) {
          filteredGenres = filteredGenres.filter(
            item => item.id !== selectedGenres[i].id
          )
        }
      }
    })

    return filteredGenres
  }

  useEffect(() => {
    setModalGenres({
      genresToSelect: getGenresToSelect(),
      selectedGenres,
    })
  }, [genres, selectedGenres])

  const handleValidate = isPlaylist => {
    if (relevantGenres && relevantGenres.length < 2) {
      return !(
        selectedInputGenres.length >= 1 && selectedInputGenres.length <= 10
      )
    }
    if (isPlaylist) {
      return !(selectedInputLanguages.length !== 0)
    }

    if (isPlaylist) {
      return !(
        selectedInputGenres.length >= 2 && selectedInputGenres.length <= 10
      )
    }

    return selectedInputGenres.length === 0
  }

  const onModalClose = () => {
    setHint(null)
    setModalGenres({
      genresToSelect: getGenresToSelect(),
      selectedGenres,
    })
    setSuccessContent(false)
    setPageTitle(true)
    toggle(false)
    setIsUpdateGenresLimitAlert(false)
  }
  const { show } = useIntercom()

  const [selectedStyleLanguagesId, setSelectedStyleLanguagesId] = useState(null)
  const [inputValueLanguages, setInputValueLanguages] = useState('')

  const optionsSelectLanguages = options => {
    if (options === undefined) return []

    const languagesOptions = options
      .filter(item => item.language_name !== 'No preference')
      .map(item => ({
        value: item.id,
        label:
          item.language_name.slice(0, 1).toUpperCase() +
          item.language_name.slice(1),
      }))
    return [...languagesOptions]
  }

  useEffect(() => {
    const selected = optionsSelectLanguages(selectedLanguages)
    setSelectedLanguages(selected)
  }, [selectedLanguages])

  const handleInputChangeLanguages = characterEntered => {
    setInputValueLanguages(characterEntered)
  }

  const onChangeSelectLanguages = (selectedOptions, { action, option }) => {
    setInputValueLanguages(inputValueLanguages)

    if (action === ActionsForSelectGenresAndLanguagesEnum.SELECT_OPTION) {
      if (option.value === 1) {
        return setSelectedLanguages([option])
      }

      const selectedOptionsWithoutNoVocal = selectedOptions.filter(
        lang => lang.value !== 1
      )

      setSelectedStyleLanguagesId(option.value)
      setTimeout(() => {
        setSelectedLanguages(selectedOptionsWithoutNoVocal)
        setSelectedStyleLanguagesId(null)
      }, 500)
    } else {
      setSelectedLanguages(selectedOptions)
    }
  }

  const formatOptionLabelLanguages = (
    { label, value },
    { inputValue, selectValue }
  ) => {
    const inputLength = inputValue.length

    const index = label.toLowerCase().indexOf(inputValue.toLowerCase())
    const selectValueLabel = selectValue.map(item => item.label)

    if (selectValueLabel.includes(label)) {
      return <div>{label}</div>
    }

    if (selectedStyleLanguagesId === value) {
      return (
        <>
          <span>
            {label.slice(0, index)}
            <strong>
              {index === 0
                ? inputValueLanguages.slice(0, 1).toUpperCase() +
                  inputValueLanguages.slice(1)
                : inputValueLanguages}
            </strong>
            {label.slice(index + inputLength)}
          </span>
          <span />
        </>
      )
    }

    return (
      <LanguagesSelectItem>
        <span>
          {label.slice(0, index)}
          <strong style={index === 0 ? { textTransform: 'capitalize' } : null}>
            {inputValueLanguages}
          </strong>
          {label.slice(index + inputLength)}
        </span>
        <span />
      </LanguagesSelectItem>
    )
  }

  const [inputValueGenres, setInputValueGenres] = useState('')

  useEffect(() => {
    const selected = selectedGenres.map(item => ({
      value: item.id,
      label:
        item.genre_name.slice(0, 1).toUpperCase() + item.genre_name.slice(1),
    }))
    setSelectedInputGenres(selected)
  }, [selectedGenres])

  const handleInputChangeGenres = characterEntered => {
    setInputValueGenres(characterEntered)
  }

  const optionsSelectGenres = items =>
    items &&
    items.map(item => ({
      value: item.id,
      label:
        item.genre_name.slice(0, 1).toUpperCase() + item.genre_name.slice(1),
    }))

  const onChangeSelectGenres = selectedOptions => {
    isGenresLimit && setGenresLimit(false)
    setInputValueGenres(inputValueGenres)
    setSelectedInputGenres(selectedOptions)
  }

  const [inputRelevantGenres, setInputRelevantGenres] = useState([])

  useEffect(() => {
    const genres =
      relevantGenres &&
      relevantGenres.filter(
        item =>
          !selectedInputGenres.find(selected => selected.value === item.id)
      )
    setInputRelevantGenres(genres)
  }, [relevantGenres, selectedInputGenres])

  const onCheckRelevantGenre = genre => {
    if (selectedInputGenres.length >= 10) {
      setGenresLimit(true)
      return
    }
    const isChecked = selectedInputGenres.find(item => item.value === genre.id)

    if (!isChecked) {
      const genres = [
        ...selectedInputGenres,
        {
          value: genre.id,
          label:
            genre.genre_name.slice(0, 1).toUpperCase() +
            genre.genre_name.slice(1),
        },
      ]
      setSelectedInputGenres(genres)
    }
  }

  const handleSetHint = hint => {
    if (hint === HINT_GENRES) {
      setHint({ component: <GenresSelectionGuide />, name: HINT_GENRES })
    }

    if (hint === HINT_LANGUAGES) {
      setHint({ component: <PlaylistVocalSettings />, name: HINT_LANGUAGES })
    }

    if (hint === CLEAR_HINT) {
      setHint({ component: null, name: null })
    }
  }

  const onSubmit = () => {
    handleSave(
      id,
      selectedInputGenres.map(item => ({
        id: Number(item.value),
        genre_name: item.label.toLowerCase(),
      })),
      selectedInputLanguages.map(item => ({
        id: Number(item.value),
        language_name: item.label,
      })),
      moodsChecked,
      (error: ErrorWithFlag) => {
        if (error && error.errorMsg[0] === UPDATE_GENRES_LIMIT) {
          setIsUpdateGenresLimitAlert(true)
        } else {
          setSuccessContent(true)
        }
      }
    )
  }

  return (
    <>
      <Desktop>
        <Modal
          fade={false}
          className="modal-dialog--success modal-dialog--header header__curator-popup"
          isOpen={isOpen}
          modalClassName="ltr-support"
          toggle={onModalClose}
          languages={languages}
        >
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              onClick={onModalClose}
            />
            <h4 className="text-modal  modal__title">
              {settingNewPlaylist
                ? t('scheduleCampaignPage.addPlaylist')
                : t('scheduleCampaignPage.editPlaylist')}
            </h4>
          </div>
          <>
            {loading ? (
              <ReactLoading
                className="users-loading loading"
                height={24}
                type="spinningBubbles"
              />
            ) : (
              <>
                {!successContent ? (
                  <>
                    <div className="playlist_wrapper">
                      {hintGuide && hintGuide.component && (
                        <div className="hintPortal">
                          {hintGuide.component}
                          <GotItContainer>
                            <WhiteGreenBtn
                              color="whiteGreen"
                              onClick={() => handleSetHint('clearHint')}
                            >
                              {t('scheduleCampaignPage.gotIt')}
                            </WhiteGreenBtn>
                          </GotItContainer>
                        </div>
                      )}
                      <div className="playlist_card">
                        <span className="playlist_url">
                          <img alt="Playlist cover" src={playListInfo.img} />
                        </span>
                        <span>
                          <h4 className="playlist_name">{playListInfo.name}</h4>
                          <h5 className="playlist_owner">
                            {t('scheduleCampaignPage.by')}&nbsp;
                            {userEmail}
                          </h5>
                        </span>
                      </div>
                    </div>
                    {meetConditions ? (
                      <>
                        <div>
                          <div className="playlist_wrapper-inner">
                            <h5 className="playlist_edit_modal-title">
                              {t('scheduleCampaignPage.genresSelectLabel')}
                            </h5>
                            {inputRelevantGenres &&
                              inputRelevantGenres.map(item => (
                                <button
                                  type="button"
                                  className="playlist_edit_modal-button"
                                  key={item.id}
                                  onClick={() => onCheckRelevantGenre(item)}
                                >
                                  {item.genre_name.slice(0, 1).toUpperCase() +
                                    item.genre_name.slice(1)}
                                </button>
                              ))}
                          </div>
                          <div className="playlist_wrapper-inner-genres">
                            <h5 className="playlist_edit_modal-title">
                              <div>
                                {t('scheduleCampaignPage.genresSelectedLabel')}
                              </div>
                              <HintGuide
                                className="hint_genres"
                                hintName="hintGenres"
                                setHintName={handleSetHint}
                                currentHint={hintGuide && hintGuide.name}
                              />
                            </h5>
                            <S.StyledSelect
                              isMulti
                              styles={customStyles}
                              classNamePrefix="genres"
                              closeMenuOnSelect={false}
                              isSearchable={false}
                              menuIsOpen={false}
                              placeholder={false}
                              value={selectedInputGenres}
                              inputValue={inputValueGenres}
                              onInputChange={handleInputChangeGenres}
                              onChange={onChangeSelectGenres}
                            />
                          </div>
                        </div>
                        {selectedInputGenres &&
                          selectedInputGenres.length < 2 &&
                          relevantGenres &&
                          relevantGenres.length > 1 && (
                            <div className="be-careful">
                              <div className="be-careful-img">
                                <img
                                  src={Warning}
                                  alt=""
                                  height="16"
                                  width="16"
                                />
                              </div>

                              <div className="be-careful-text">
                                {t(
                                  'scheduleCampaignPage.minimum2GenresAreRequired'
                                )}
                              </div>
                            </div>
                          )}

                        {isGenresLimit && (
                          <S.AlertWrapper>
                            <Alert color="warning" icon>
                              <S.AlertText>
                                {t('targetGenres.youCanSelectOnly10Genres')}
                              </S.AlertText>
                            </Alert>
                          </S.AlertWrapper>
                        )}
                        <div className="be-careful">
                          <DottedBtn
                            content={t(
                              'scheduleCampaignPage.haveIssuesWithGenres'
                            )}
                            onClick={show}
                          />
                        </div>
                        {/* <MoodsComponent
                          moodTooltipShown={moodTooltipShown}
                          moodsChecked={moodsChecked}
                          setMoodsChecked={setMoodsChecked}
                        /> */}
                        <div className="targetLanguage_wrapper">
                          <div className="targetLanguage-title">
                            <div>
                              {t('scheduleCampaignPage.targetLanguages')}
                            </div>
                            <HintGuide
                              className="hint_languages"
                              hintName="hintLanguages"
                              setHintName={handleSetHint}
                              currentHint={hintGuide && hintGuide.name}
                            />
                          </div>
                          <div>
                            <S.StyledSelect
                              isMulti
                              placeholder={t(
                                'createCampaignPage.startTypingLanguageName'
                              )}
                              styles={customStyles}
                              classNamePrefix="language-select"
                              closeMenuOnSelect={false}
                              options={optionsSelectLanguages(languages)}
                              value={selectedInputLanguages}
                              inputValue={inputValueLanguages}
                              components={{ DropdownIndicator }}
                              formatOptionLabel={formatOptionLabelLanguages}
                              onInputChange={handleInputChangeLanguages}
                              onChange={onChangeSelectLanguages}
                            />
                          </div>
                        </div>
                      </>
                    ) : (
                      <S.IrrelevantContainer>
                        <S.IrrelevantTitleRow>
                          <S.IrrelevantIcon src={IconDanger} alt="" />
                          <S.IrrelevantTitleText>
                            {t('targetGenres.noRelevantTitle')}
                          </S.IrrelevantTitleText>
                        </S.IrrelevantTitleRow>
                        <S.IrrelevantDescription>
                          <S.IrrelevantDescriptionUnderline
                            href={playlistRequirementsLink}
                            target="_blank"
                          >
                            {t('targetGenres.contactSupport')}
                          </S.IrrelevantDescriptionUnderline>
                          {t('targetGenres.toSolveThisIssue')}
                        </S.IrrelevantDescription>
                      </S.IrrelevantContainer>
                    )}
                    {isUpdateGenresLimitAlert && (
                      <S.AlertWrapper success>
                        <Alert color="success" icon unclosable noGap>
                          <S.AlertText success>
                            {t('targetGenres.updateOnlyOncePerDayAlert')}
                          </S.AlertText>
                        </Alert>
                      </S.AlertWrapper>
                    )}
                    <div className="apply_btn">
                      {!handleValidate(isPlaylist) ? (
                        <GreenBtn color="green" onClick={onSubmit}>
                          {t('targetGenres.save')}
                        </GreenBtn>
                      ) : (
                        <GreyBtnDisabled color="greyDisabled" disabled>
                          {t('targetGenres.save')}
                        </GreyBtnDisabled>
                      )}
                    </div>
                  </>
                ) : (
                  <>
                    <S.SuccessContainer>
                      <S.SuccessIcon src={CheckedCircleIcon} alt="" />
                      <S.SuccessText>
                        {settingNewPlaylist
                          ? t('scheduleCampaignPage.successTextAdd')
                          : t('scheduleCampaignPage.successTextEdit')}
                      </S.SuccessText>
                    </S.SuccessContainer>
                    <S.SuccessButtonContainer>
                      <GreenBtn color="white" onClick={onModalClose}>
                        {t('targetGenres.continue')}
                      </GreenBtn>
                    </S.SuccessButtonContainer>
                  </>
                )}
              </>
            )}
          </>
        </Modal>
      </Desktop>
      <Mobile>
        {isOpen && !successContent && (
          <>
            <S.PageTitleRow>
              <S.BackButton src={arrowLeftIcon} alt="" onClick={onModalClose} />
              <S.PageTitle>
                {settingNewPlaylist
                  ? t('scheduleCampaignPage.addPlaylist')
                  : t('scheduleCampaignPage.editPlaylist')}
              </S.PageTitle>
            </S.PageTitleRow>
            <>
              {loading ? (
                <ReactLoading
                  className="users-loading loading"
                  height={24}
                  type="spinningBubbles"
                />
              ) : (
                <>
                  <S.ContentBlock>
                    <div className="playlist_card">
                      <span className="playlist_url">
                        <img alt="Playlist cover" src={playListInfo.img} />
                      </span>
                      <span>
                        <h4 className="playlist_name">{playListInfo.name}</h4>
                        <h5 className="playlist_owner">
                          {t('scheduleCampaignPage.by')}&nbsp;
                          {userEmail}
                        </h5>
                      </span>
                    </div>
                  </S.ContentBlock>

                  {meetConditions ? (
                    <S.ContentBlock last>
                      <div>
                        <div className="playlist_wrapper-inner-mobile">
                          <h5 className="playlist_edit_modal-title-mobile">
                            {t('scheduleCampaignPage.genresSelectLabel')}
                          </h5>
                          {inputRelevantGenres &&
                            inputRelevantGenres.map(item => (
                              <button
                                type="button"
                                className="playlist_edit_modal-button"
                                key={item.id}
                                onClick={() => onCheckRelevantGenre(item)}
                              >
                                {item.genre_name.slice(0, 1).toUpperCase() +
                                  item.genre_name.slice(1)}
                              </button>
                            ))}
                        </div>
                        <div className="playlist_wrapper-inner-genres-mobile">
                          <h5 className="playlist_edit_modal-title-mobile">
                            <div>
                              {t('scheduleCampaignPage.genresSelectedLabel')}
                            </div>
                            <HintGuide
                              className="hint_genres"
                              hintName="hintGenres"
                              setHintName={setModalValue}
                              currentHint={hintGuide && hintGuide.name}
                            />
                            <GenresSelectionGuideModal
                              isOpen={modal}
                              toggle={setModalValue}
                            />
                          </h5>
                          <S.StyledSelect
                            isMulti
                            styles={customStyles}
                            classNamePrefix="genres"
                            closeMenuOnSelect={false}
                            isSearchable={false}
                            menuIsOpen={false}
                            placeholder={false}
                            value={selectedInputGenres}
                            inputValue={inputValueGenres}
                            onInputChange={handleInputChangeGenres}
                            onChange={onChangeSelectGenres}
                          />
                        </div>
                      </div>
                      {selectedInputGenres &&
                        selectedInputGenres.length < 2 &&
                        relevantGenres &&
                        relevantGenres.length > 1 && (
                          <div className="be-careful-mobile">
                            <div className="be-careful-img">
                              <img
                                src={Warning}
                                alt=""
                                height="16"
                                width="16"
                              />
                            </div>

                            <div className="be-careful-text">
                              {t(
                                'scheduleCampaignPage.minimum2GenresAreRequired'
                              )}
                            </div>
                          </div>
                        )}

                      <div className="be-careful-mobile-btn">
                        <DottedBtn
                          content={t(
                            'scheduleCampaignPage.haveIssuesWithGenres'
                          )}
                          onClick={show}
                        />
                      </div>
                      {/* <MoodsComponent
                        moodTooltipShown={moodTooltipShown}
                        moodsChecked={moodsChecked}
                        mobile
                        setMoodsChecked={setMoodsChecked}
                      /> */}
                      <div className="targetLanguage_wrapper-mobile">
                        <div className="targetLanguage-title">
                          <div>{t('scheduleCampaignPage.targetLanguages')}</div>
                          <HintGuide
                            className="hint_languages"
                            hintName="hintLanguages"
                            setHintName={setModalValueVocal}
                            currentHint={hintGuide && hintGuide.name}
                          />
                          <PlaylistVocalSettingsModal
                            isOpen={modalVocal}
                            toggle={setModalValueVocal}
                          />
                        </div>
                        <div>
                          <S.StyledSelect
                            isMulti
                            placeholder={t(
                              'createCampaignPage.startTypingLanguageName'
                            )}
                            styles={customStyles}
                            classNamePrefix="language-select"
                            closeMenuOnSelect={false}
                            options={optionsSelectLanguages(languages)}
                            value={selectedInputLanguages}
                            inputValue={inputValueLanguages}
                            components={{ DropdownIndicator }}
                            formatOptionLabel={formatOptionLabelLanguages}
                            onInputChange={handleInputChangeLanguages}
                            onChange={onChangeSelectLanguages}
                          />
                        </div>
                      </div>
                    </S.ContentBlock>
                  ) : (
                    <S.ContentBlock last>
                      <S.IrrelevantContainer>
                        <S.IrrelevantTitleRow>
                          <S.IrrelevantIcon src={IconDanger} alt="" />
                          <S.IrrelevantTitleText>
                            {t('targetGenres.noRelevantTitle')}
                          </S.IrrelevantTitleText>
                        </S.IrrelevantTitleRow>
                        <S.IrrelevantDescription>
                          <S.IrrelevantDescriptionUnderline
                            href={playlistRequirementsLink}
                            target="_blank"
                          >
                            {t('targetGenres.contactSupport')}
                          </S.IrrelevantDescriptionUnderline>
                          {t('targetGenres.toSolveThisIssue')}
                        </S.IrrelevantDescription>
                      </S.IrrelevantContainer>
                    </S.ContentBlock>
                  )}
                  <S.MobileButtonContainer>
                    {!handleValidate(isPlaylist) ? (
                      <GreenBtn color="green" onClick={onSubmit}>
                        {t('targetGenres.save')}
                      </GreenBtn>
                    ) : (
                      <GreyBtnDisabled color="greyDisabled" disabled>
                        {t('targetGenres.save')}
                      </GreyBtnDisabled>
                    )}
                  </S.MobileButtonContainer>
                </>
              )}
            </>
          </>
        )}
        {isOpen && successContent && (
          <ModalMobile visible={isOpen} footer={null} closable={null}>
            <S.SuccessContainerMobile>
              <S.SuccessContainer mobile>
                <S.SuccessIcon src={CheckedCircleIcon} alt="" mobile />
                <S.SuccessText>
                  {settingNewPlaylist
                    ? t('scheduleCampaignPage.successTextAdd')
                    : t('scheduleCampaignPage.successTextEdit')}
                </S.SuccessText>
              </S.SuccessContainer>
              <S.SuccessButtonContainer>
                <GreenBtn color="white" onClick={onModalClose}>
                  {t('targetGenres.save')}
                </GreenBtn>
              </S.SuccessButtonContainer>
            </S.SuccessContainerMobile>
          </ModalMobile>
        )}
      </Mobile>
    </>
  )
}

export default PlaylistEditModal
